/*istanbul ignore next*/'use strict';

var Directive = require('../directive');

module.exports = new Directive({
  update: function /*istanbul ignore next*/update(newValue) {
    this.node.innerText = newValue;
  }
});


// WEBPACK FOOTER //
// ./~/_mokit@3.1.3@mokit/lib/template/directives/inner-text.js